import type { FC } from 'react';
import { useState } from 'react';

import SearchIcon from '@mui/icons-material/Search';
import {
  Avatar,
  Badge,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  Typography,
} from '@mui/material';
import Stack from '@mui/material/Stack';

import WaveUIForm_V2 from '@/shared/components/forms/WaveUIForm_V2';
import FieldType from '@/shared/components/forms/WaveUIForm_V2/types/fieldType.enum';
import useAuth from '@/shared/contexts/auth/hooks/useAuth';

import NavList from './components/NavList';

type NavBarProps = {
  isDrawerOpened: boolean;
};

const NavBar: FC<NavBarProps> = ({ isDrawerOpened }) => {
  const { user } = useAuth();

  const [search, setSearch] = useState('');

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setSearch(event.target.value);

  return (
    <Stack
      sx={{
        px: 1,
        py: 2,
        height: '100%',
      }}
      useFlexGap
      spacing={1}
    >
      {isDrawerOpened && (
        <WaveUIForm_V2
          fields={[
            {
              field_type: FieldType.Text,
              field_props: {
                name: 'search',
                label: '',
                placeholder: 'Search...',
                value: search,
                disabled: true,
                sx: {
                  width: '90%',
                },
                onChange: handleSearchChange,
                startAdornment: (
                  <SearchIcon
                    sx={{
                      width: 20,
                      height: 20,
                      color: 'text.secondary',
                    }}
                  />
                ),
                inputProps: {
                  sx: {
                    p: 1.2,
                  },
                },
              },
            },
          ]}
          getFieldsValues={(value) => {
            const { search } = value;
            setSearch(search as string);
          }}
        />
      )}

      <NavList />

      <List sx={{ mt: 'auto' }}>
        <Divider sx={{ my: 1 }} />
        <ListItem sx={{ px: 1, borderRadius: 4 }}>
          <ListItemAvatar>
            <Badge
              color='success'
              variant='dot'
              overlap='circular'
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              sx={{
                '& .MuiBadge-dot': {
                  width: 12,
                  height: 12,
                  borderRadius: '50%',
                  border: '2px solid #fff',
                },
              }}
            >
              <Avatar>
                {user && user.first_name.charAt(0) + user.last_name.charAt(0)}
              </Avatar>
            </Badge>
          </ListItemAvatar>

          <Typography component='div' noWrap>
            {user?.first_name}
          </Typography>
        </ListItem>
      </List>
    </Stack>
  );
};
export default NavBar;
